module.exports = __webpack_public_path__ + "img/layers.70d20877.svg";